import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

function AuthSuccessPage() {
  const navigate = useNavigate()
  const { refetchUser } = useAuth()

  useEffect(() => {
    const completeLogin = async () => {
      // Cookie is already set by the server
      // Just refetch the user to update context
      await refetchUser()

      // Get redirect path from sessionStorage
      const redirectPath = sessionStorage.getItem('authRedirect') || '/'
      sessionStorage.removeItem('authRedirect')

      navigate(redirectPath, { replace: true })
    }

    void completeLogin()
  }, [refetchUser, navigate])

  return (
    <div className="auth-success-page">
      <div className="container">
        <div className="success-container">
          <div className="success-icon">✓</div>
          <h1>Ověření úspěšné!</h1>
          <p>Přesměrování do aplikace...</p>
        </div>
      </div>
    </div>
  )
}

export default AuthSuccessPage
